export default __webpack_public_path__ + "static/media/img-0405-austria-full-face.a546d669.png";